import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ConfirmationPage from './pages/ConfirmationPage';
import CultureAssessmentPage from './pages/CultureAssessmentPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
          <Route path="/culture-assessment" element={<CultureAssessmentPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
